/*
 * Experimental flux implementation based on redux patters
 */

import {
  registerStores,
  setState,
  getState,
  reduceAction,
  stateChangedFor,
  stateMap,
} from './state';

import { connect } from './wrapper';

const _listeners = {};
let _lastKey = 0;

export function addListener(interests, handler) {
  _listeners[_lastKey] = { interests, handler };
  _lastKey += 1;
  return _lastKey - 1;
}

export function removeListener(index) {
  delete _listeners[index];
}

export function dispatch(action) {
  const prevState = getState();
  const changedCache = {};
  const nextState = reduceAction(action);

  setState(nextState);

  for (const index in _listeners) {
    const { interests, handler } = _listeners[index];

    if (stateChangedFor(interests, prevState, changedCache)) {
      handler.call(null, stateMap(interests));
    }
  }

  window.lastChanged = changedCache;
}

export { registerStores, setState, getState } from './state';
export { connect } from './wrapper';
